<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="classMsg.dialog"
      persistent
      content-class="notice-modal"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          {{classMsg.title}}
        </v-card-title>

        <v-card-text>
          <!-- <button @click="invokeHtmlMethod">调用html方法</button> -->
          <iframe name= "iframeMap" id="iframeMapViewComponent" src="/static/noticeIframe.html"
                width="100%" height="500"
                frameborder="0" ref="iframeDom"
        ></iframe>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="doRefuse" >Refuse</v-btn>
          <v-btn color="success" @click="readAndAccept" >Read and Accept</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="refuse.dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">give the reason here</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>

              <v-flex xs12>
                <v-textarea
                  solo
                  name="input-7-4"
                  v-model="refuse.reason"
                ></v-textarea>
              </v-flex>

            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="refuseCancle">Cancle</v-btn>
          <v-btn color="blue darken-1" flat @click="refuseSubmit">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { noticeSendRefuse, readClassMsg } from '@/api/layout'
import signalrNotify from '@/utils/signalR'
import {
  mapGetters
} from 'vuex'
export default {
  data () {
    return {
      refuse: {
        dialog: false,
        reason: ''
      },
    }
  },
  computed: {
    ...mapGetters([
      'classMsg'
    ]),
  },
  mounted () {

  },
  methods: {

    setIframeContent() {
      window.frames['iframeMap'].lodaTable(this.classMsg.content)
    },
    doRefuse () {
      this.refuse.dialog = true
      this.$store.dispatch('closeClassMsg',true)
    },
    refuseCancle () {
      this.refuse.dialog = false
        this.$store.dispatch('openClassMsg')
    },
    refuseSubmit () {
      if (this.refuse.reason.trim().length < 1) {
        // pls give the reason why u Refuse
        this.$root.$alertTips('pls give the reason why u Refuse')
        return
      }
      noticeSendRefuse(this.classMsg.mid, this.refuse.reason).then(res => {
        
        this.$store.dispatch('closeClassMsg')
        let result = res.data
        this.refuse.dialog = false
        if (result.ErrorCode === 0) {

        } else {
          this.$root.$alertTips(result.Msg)
        }
      })
    },
    readAndAccept () {
      readClassMsg(this.classMsg.mid).then(res => {
        let result = res.data
        this.$store.dispatch('closeClassMsg')
        if (result.ErrorCode === 0) {
          //
        } else {
          this.$root.$alertTips(result.Msg)
        }
      })
    }
  },
  watch: {
    'classMsg.content': function(value){
      this.setIframeContent()
    }
  }
}
</script>
<style lang="scss">
.notice-modal{
    min-width: 800px;
    width: auto;
    max-width: 60%;
    word-break: break-word;
    img{
      max-width: 100%;
    }
    @media screen and (max-width: 800px) {
        min-width: 100%;
    }
}
[data-theme="theme1"] .notice-modal .theme--light.v-sheet{
    color: #32397A !important;
    background: #fff!important;
}
</style>

